<!-- breadcrumb item -->
<div class="row">
  <div class="col-12">
    @if (icon || subtitle) {
      <!-- Novo layout com ícone e subtítulo -->
      <div class="mb-4">
        <div class="d-sm-flex align-items-center justify-content-between ms-2">
          <h2 class="mb-0">
            @if (icon) {
              <i [class]="icon + ' me-2'"></i>
            }
            {{ title }}
          </h2>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              @for (item of breadcrumbItems; track $index) {
                <ng-container>
                  <li
                    class="breadcrumb-item"
                    [ngClass]="{ active: item.active == true }"
                  >
                    {{ item.label }}
                  </li>
                </ng-container>
              }
            </ol>
          </div>
        </div>
        @if (subtitle) {
          <p class="text-muted mb-0 ms-2">{{ subtitle }}</p>
        }
      </div>
    } @else {
      <!-- Layout original (compatibilidade) -->
      <div
        class="page-title-box d-sm-flex align-items-center justify-content-between ms-2"
      >
        <h4 class="mb-sm-0 font-size-18">{{ title }}</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            @for (item of breadcrumbItems; track $index) {
              <ng-container>
                <li
                  class="breadcrumb-item"
                  [ngClass]="{ active: item.active == true }"
                >
                  {{ item.label }}
                </li>
              </ng-container>
            }
          </ol>
        </div>
      </div>
    }
  </div>
</div>
